var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65835 8.3252C2.11858 8.3252 2.49168 7.9521 2.49168 7.49186C2.49168 7.03162 2.11858 6.65853 1.65835 6.65853C1.19811 6.65853 0.825012 7.03162 0.825012 7.49186C0.825012 7.9521 1.19811 8.3252 1.65835 8.3252Z",
    stroke: "currentColor",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65835 2.49186C2.11858 2.49186 2.49168 2.11877 2.49168 1.65853C2.49168 1.19829 2.11858 0.825195 1.65835 0.825195C1.19811 0.825195 0.825012 1.19829 0.825012 1.65853C0.825012 2.11877 1.19811 2.49186 1.65835 2.49186Z",
    stroke: "currentColor",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65835 14.1585C2.11858 14.1585 2.49168 13.7854 2.49168 13.3252C2.49168 12.865 2.11858 12.4919 1.65835 12.4919C1.19811 12.4919 0.825012 12.865 0.825012 13.3252C0.825012 13.7854 1.19811 14.1585 1.65835 14.1585Z",
    stroke: "currentColor",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.df05a8ef5631dcee52c0bb314c5e7927.svg";
export { ForwardRef as ReactComponent };